import StrategyConsult from "../../../assets/img/strategy.png";
import EarnedMedia from "../../../assets/img/earnedmedia.png";
import PaidMedia from "../../../assets/img/paidmedia.png";
import ContentMarket from "../../../assets/img/contentmarket.png";
import CreativeManagement from "../../../assets/img/creativemarket.png";
import EmailMarket from "../../../assets/img/emailmarket.png";
import { cardData } from "../../../types/Types";
export const marketingServices: cardData[] = [
  {
    image: StrategyConsult,
    title: "Strategy & Consulting",
    description:
      "Configuring your brand and supporting you in taking decisive measures.",
    link: "/services#strategy-consulting",
    id: "",
    icon: "symbol",
  },
  {
    image: EarnedMedia,
    title: "Earned & Owned Media",
    description:
      "Creating frameworks for organizing and executing your marketing to extend your reach.",
    link: "/services#earned-owned-media",
    id: "",
    icon: "symbol",
  },
  {
    image: PaidMedia,
    title: "Paid Media",
    description:
      "Promoting brands using paid methods to increase brand awareness and generate more traffic.",
    link: "/services#paid-media",
    id: "",
    icon: "symbol",
  },
  {
    image: ContentMarket,
    title: "Content Marketing",
    description:
      "Generating and disseminating valuable, relevant, and consistent content.",
    link: "/services#content-marketing",
    id: "",
    icon: "symbol",
  },
  {
    image: CreativeManagement,
    title: "Creative Management",
    description:
      "Connecting brands with customers through compelling creatives.",
    link: "/services#creative-management",
    id: "",
    icon: "symbol",
  },
  {
    image: EmailMarket,
    title: "Email Marketing",
    description:
      "Promoting your brand through highly targeted and personalised content to the right audience and accounts.",
    link: "/services#email-marketing",
    id: "",
    icon: "symbol",
  },
];
